import { useTranslation } from '@pancakeswap/localization'
import { Balance, Box, CheckmarkCircleFillIcon, Flex, FlexGap, Text, useModal } from '@pancakeswap/uikit'
import { DoubleCurrencyLogo, TripleCurrencyLogo } from 'components/Logo'
import { useCurrency } from 'hooks/Tokens'
import styled from 'styled-components'
import { PoolData } from '../hooks/usePools'
import AddModalStable from './AddModalStable'
import IncreaseModal from './IncreaseModal'

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 120px;
  width: 100%;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    font-size: 12px;
    row-gap: 8px;
  }
`

const PoolPanel = styled(Box)`
  cursor: pointer;
  background: #FFFFFF0D;
  &:hover {
    background: #FFFFFF08;
  }
`

const FeeTier = styled(Text)`
  border: 2px solid ${({ theme }) => theme.colors.textSubtle};
  border-radius: 8px;
  padding: 3px 4px;
  font-size: 12px;
  font-weight: bold;
  line-height: 12px;
  opacity: 0.5;
`

const FarmButton = styled(Text)`
  border-radius: 8px;
  padding: 5px 5px;
  font-size: 12px;
  font-weight: bold;
  line-height: 12px;
  background: #2EBF43;
  border-radius: 8px;
`

const PStableLabel = styled(Text)`
  border-radius: 8px;
  padding: 5px 5px;
  font-size: 12px;
  font-weight: bold;
  line-height: 12px;
  background: #2EBF43;
  color: ${({ theme }) => theme.colors.backgroundAlt};
`

const StyledBalance = ({ value, ...props }: any) => {
	if (!value) {
		return <Text fontSize={16} color="textSubtle">-</Text>
	}
	return <Balance value={value} {...props} />
}

const PoolItemHeader = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`

const CurrencyInfo = styled(Flex)`
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

const TagsContainer = styled(Flex)`
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
  
  @media (max-width: 576px) {
    width: 100%;
  }
`

const StakeableTag = styled(Flex)`
  align-items: center;
  white-space: nowrap;
`

const abbr = (symbol: string) => {
	if (!symbol || symbol.length < 10)
		return symbol
	return `${symbol.slice(0, 4)}...${symbol.slice(-4)}`
}

const PoolItem = ({ pool, onDone }: { pool: PoolData, onDone: () => void }) => {
	const { t } = useTranslation()
	const currency0 = useCurrency(pool.token0.address)
	const currency1 = useCurrency(pool.token1.address)
	const currency2 = useCurrency(pool.token2?.address)

	const [onPresentIncreaseModal] = useModal(
		pool.version === 'v3'
			? <IncreaseModal
				key={`increase-modal-${pool.address}`}
				currencyA={currency0}
				currencyB={currency1}
				poolData={pool}
				onDone={onDone}
			/>
			: <AddModalStable onDone={onDone} />,
		true,
		true,
		`increase-v3-liquidity-${pool.address}`
	)

	if (currency0 && currency1)
		return (
			<PoolPanel key={pool.address} p="16px 20px" borderRadius="16px" onClick={onPresentIncreaseModal}>
				<PoolItemHeader>
					<CurrencyInfo>
						{currency2
							? <TripleCurrencyLogo currency0={currency0} currency1={currency1} currency2={currency2} size={24} margin={10} />
							: <DoubleCurrencyLogo currency0={currency0} currency1={currency1} size={24} />
						}
						<Text>
							{currency0?.symbol} - {currency1?.symbol}
							{!!currency2 && ` - ${currency2.symbol}`}
						</Text>
					</CurrencyInfo>

					<TagsContainer>
						{pool.version === 'v3' && <FeeTier>{pool.feeTier}%</FeeTier>}

						{pool.version === 'stable' && <PStableLabel fontSize={16}>{`pStable LP`}</PStableLabel>}

						{/* {pool.farm && (
							<StakeableTag>
								<Text mr="5px" fontSize={12} color="textSubtle">Stakeable LP</Text>
								<CheckmarkCircleFillIcon color="success" />
							</StakeableTag>
						)} */}
					</TagsContainer>
				</PoolItemHeader>

				<Flex justifyContent="center">
					<Grid>
						<div>
							<Text fontSize={12} color="textSubtle">Liquidity</Text>
							<StyledBalance pack value={pool.liquidity} decimals={2} prefix="$" />
						</div>
						<div>
							<Text fontSize={12} color="textSubtle">Volume 24H</Text>
							<StyledBalance pack value={pool.volume1d} decimals={2} prefix="$" />
						</div>
						<div>
							<Text fontSize={12} color="textSubtle">APR</Text>
							<StyledBalance value={pool.apr1d} decimals={2} unit="%" />
						</div>
						<div>
							<Text fontSize={12} color="textSubtle">Earn</Text>
							{/* {
								pool.version === 'stable'
									? <Text fontSize={14} lineHeight="30px">{`Fees + pStableLP`}</Text>
									: <Text fontSize={14} lineHeight="30px">{`Fees${pool.farm ? ' + Points' : ''}`}</Text>
							} */}

							{
								pool.version === 'stable'
									? <Text fontSize={14} lineHeight="30px">{`Fees + pStableLP`}</Text>
									: <Text fontSize={14} lineHeight="30px">{`Fees`}</Text>
							}
						</div>
					</Grid>
				</Flex>
			</PoolPanel>
		)
	return null
}

export default PoolItem